export default __webpack_public_path__ + "static/media/pulse.b3ef1653.svg";